"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dynamicMask = void 0;
const dynamicMask = (maskIt, masks, tokens) => {
    masks = masks.sort((a, b) => a.length - b.length);
    return function (value, masked = true) {
        let i = 0;
        while (i < masks.length) {
            const currentMask = masks[i];
            i++;
            const nextMask = masks[i];
            if (!(nextMask &&
                maskIt(value, nextMask, tokens, true).length > currentMask.length)) {
                return maskIt(value, currentMask, tokens, masked);
            }
        }
        return "";
    };
};
exports.dynamicMask = dynamicMask;
